/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DdexResourceContributor
 */
export interface DdexResourceContributor {
    /**
     * Contributor name
     * @type {string}
     * @memberof DdexResourceContributor
     */
    name: string;
    /**
     * Contributor roles
     * @type {Array<string>}
     * @memberof DdexResourceContributor
     */
    roles: Array<string>;
    /**
     * Sequence number for ordering
     * @type {number}
     * @memberof DdexResourceContributor
     */
    sequenceNumber?: number;
}

/**
 * Check if a given object implements the DdexResourceContributor interface.
 */
export function instanceOfDdexResourceContributor(value: object): value is DdexResourceContributor {
    let isInstance = true;
    isInstance = isInstance && "name" in value && value["name"] !== undefined;
    isInstance = isInstance && "roles" in value && value["roles"] !== undefined;

    return isInstance;
}

export function DdexResourceContributorFromJSON(json: any): DdexResourceContributor {
    return DdexResourceContributorFromJSONTyped(json, false);
}

export function DdexResourceContributorFromJSONTyped(json: any, ignoreDiscriminator: boolean): DdexResourceContributor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'roles': json['roles'],
        'sequenceNumber': !exists(json, 'sequence_number') ? undefined : json['sequence_number'],
    };
}

export function DdexResourceContributorToJSON(value?: DdexResourceContributor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'roles': value.roles,
        'sequence_number': value.sequenceNumber,
    };
}

